"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LenkepanelBase = void 0;
const PT = __importStar(require("prop-types"));
const React = __importStar(require("react"));
const nav_frontend_typografi_1 = __importDefault(require("nav-frontend-typografi"));
require("nav-frontend-lenkepanel-style");
const Lenkepanel_base_1 = __importDefault(require("./Lenkepanel-base"));
class Lenkepanel extends React.PureComponent {
    render() {
        const _a = this.props, { children, tittelProps = "undertittel" } = _a, renderProps = __rest(_a, ["children", "tittelProps"]);
        const headingConfig = { type: tittelProps, tag: "span" };
        // eslint-disable-next-line max-len
        const heading = (React.createElement(nav_frontend_typografi_1.default, Object.assign({ key: "heading" }, headingConfig, { className: "lenkepanel__heading" }), children));
        return React.createElement(Lenkepanel_base_1.default, Object.assign({}, renderProps), heading);
    }
}
Lenkepanel.propTypes = {
    /**
     * Klassenavn
     */
    className: PT.string,
    /**
     * Lenke (denne sendes som prop til linkCreator)
     */
    href: PT.string.isRequired,
    /**
     * Tekstinnhold for lenkepanel
     */
    children: PT.oneOfType([PT.arrayOf(PT.node), PT.node]).isRequired,
    /**
     * Typografitype
     */
    tittelProps: PT.string,
    /**
     * Funksjon som brukes for å lage lenken. her kan du spessifisere din egen hvis du f.eks. bruker React Router
     */
    linkCreator: PT.func,
};
Lenkepanel.defaultProps = {
    className: undefined,
    tittelProps: "undertittel",
    linkCreator: (props) => React.createElement("a", Object.assign({}, props), props.children),
};
exports.default = Lenkepanel;
var Lenkepanel_base_2 = require("./Lenkepanel-base");
Object.defineProperty(exports, "LenkepanelBase", { enumerable: true, get: function () { return __importDefault(Lenkepanel_base_2).default; } });
